<!-- el-form :model=props.propsValue 使用双向绑定直接修改父组件传入的propsValue，此处违反单向数据流但处理更简单 -->
<template>
  <div class="common-form-component">
    <el-form ref="formRef" :model="formData" :rules="props.rules" label-position="top">
      <div class="edit-form-item" v-for="(item, index) in propsList" :key="item.prop">
        <el-form-item
          class="item-style"
          :label-width="props.labelWidth"
          :label="props.showLable ? item.label : ''"
          :prop="item.prop"
        >
          <template v-if="item.labelDesc" #label>
            <div class="el-form-item__label custom-label">
              {{ item.label }}
              <el-popover
                placement="top-start"
                :width="300"
                trigger="hover"
                :content="item.labelDesc || ''"
                popper-style="fontSize:12px"
              >
                <template #reference>
                  <span
                    ><el-icon :size="15"><QuestionFilled /></el-icon
                  ></span>
                </template>
              </el-popover>
            </div>
          </template>
          <slot v-if="item.slotName" :name="item.slotName" :prop="item"></slot>
          <template v-else>
            <!-- 嵌套的ref不会解包 -->
            <!-- 10 输入框 -->
            <el-input
              v-if="item.type == '10'"
              v-model="formData[item.prop]"
              :placeholder="'请输入' + item.label"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
              :readonly="'readonly' in item ? !!item.readonly : false"
              :maxlength="item.maxLength ?? 100"
            ></el-input>
            <!-- 11 文本域 -->
            <el-input
              v-if="item.type == '11'"
              type="textarea"
              v-model="formData[item.prop]"
              :placeholder="'请输入' + item.label"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
              :show-word-limit="!!(item.showWordLimit ?? (item.maxLength ? true : false))"
              :maxlength="item.maxLength"
            ></el-input>

            <!-- 20 日期区间选择框 -->
            <el-date-picker
              v-if="item.type == '20'"
              type="daterange"
              v-model="formData[item.prop]"
              value-format="YYYY-MM-DD"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
            ></el-date-picker>
            <!-- 21 日期时间选择框 -->
            <el-date-picker
              v-if="item.type == '21'"
              type="datetime"
              v-model="formData[item.prop]"
              value-format="YYYY-MM-DD HH:mm:ss"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
            ></el-date-picker>
            <!-- 22 日期选择框 -->
            <el-date-picker
              v-if="item.type == '22'"
              type="date"
              v-model="formData[item.prop]"
              value-format="YYYY-MM-DD"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
            ></el-date-picker>

            <!-- 30 下拉框 -->
            <el-select
              v-if="item.type == '30'"
              v-model="formData[item.prop]"
              :placeholder="'请选择' + item.label"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
            >
              <!--  el-select 选项值集，默认数据结构[{label:'',value:''}] -->
              <el-option
                v-for="(optionItem, optionItemIndex) in item.options"
                :key="optionItemIndex"
                :label="optionItem[item?.optionItemKeysMap?.label || 'label']"
                :value="optionItem[item?.optionItemKeysMap?.value || 'value']"
              ></el-option>
            </el-select>

            <!-- 50 自动补全输入框 -->
            <el-autocomplete
              v-if="item.type == '50'"
              v-model="formData[item.prop]"
              :fetch-suggestions="item.queryFetch"
              :placeholder="'请选择' + item.label"
              :clearable="'clearable' in item ? !!item.clearable : true"
              :disabled="'disabled' in item ? !!item.disabled : false"
            ></el-autocomplete>

            <!-- 70 单选 -->
            <el-radio-group
              v-if="item.type == '70'"
              v-model="formData[item.prop]"
              :disabled="'disabled' in item ? !!item.disabled : false"
            >
              <el-radio
                v-for="(optionItem, optionItemIndex) in item.options"
                :key="optionItemIndex"
                :label="optionItem[item?.optionItemKeysMap?.value || 'value']"
                >{{ optionItem[item?.optionItemKeysMap?.label || 'label'] }}</el-radio
              >
            </el-radio-group>

            <!-- 80 文件上传 -->
            <file-upload
              :ref="el => setRef(el, item)"
              v-if="item.type == '80'"
              :button-text="item.buttonText"
              @uploadSuccess="uploadSuccessCB"
            />
          </template>
        </el-form-item>
      </div>
      <div v-if="props.btnPlacement === 'left'" :class="['btn-block', props.btnPlacement]">
        <el-button type="primary" size="default" @click="handleSave">保存</el-button>
        <el-button size="default" @click="handleCancel">取消</el-button>
      </div>
      <div v-else :class="['btn-block', props.btnPlacement]">
        <el-button size="default" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="default" @click="handleSave">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, reactive, ref, toRefs, onBeforeMount, watch, nextTick } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { BaseObject } from '@/types/index'
// import FileUpload from './FileUpload.vue'
// import { findValueBySetCode } from '@/api/common'

// el-select options 选项类型
interface OptionItem {
  label?: string
  value?: any
  [index: string]: any
}
// el-option label/value 使用其他字段名的映射
interface OptionItemKeysMap {
  label: string
  value: string
}

// el-form-item 数据类型
interface FormItem {
  type: '10' | '11' | '20' | '21' | '22' | '30' | '40' | '50' | '60' | '70' | '80' // 10:el-input, 11:el-input.textarea, 20:el-date-picker, 30:el-select, 50:el-autocomplete,  70:单选框, 80:文件上传
  label: string // 表单项 label
  prop: string // 表单项 prop
  clearable?: boolean // 表单项 是否可清除，默认 true
  options?: OptionItem[] // 表单项是el-select且选项是值集时，查询到的选项列表，接口数据结构 [{value:'', name:''}]
  valueSetCode?: string // 表单项是el-select且选项是值集时，查询值集的code
  optionItemKeysMap?: OptionItemKeysMap // 表单项是el-select且选项非值集时，<el-option>使用的属性的映射
  slotName?: string // 插槽名，有值即表示使用插槽
  disabled?: boolean // 是否禁用
  readonly?: boolean // 是否只读
  elColSpan?: number // el-form-item :span的值
  showAllLevels?: boolean // 表单项是el-cascader时，show-all-levels
  queryFetch?: (queryString: string, cb: any) => void // 表单项是el-autocomplete时，fetch-suggestions
  maxLength?: number
  showWordLimit?: boolean
  labelDesc?: string //el-form-item label 描述信息
  buttonText?: string //80上传组件，按钮文字
  rows?: number //11textarea
}
// 如何定义PropsValue的对象类型，使包含所有propsList的prop，运行时确定propsList，无法校验？？？TODO
// interface PropsValue<T extends FormItem> {
//   [p in keyof T]:any
// }
// props的类型声明、默认值。（vue3要求，类型声明参数：类型字面量；在同一文件中的接口或类型字面量的引用）
const props = withDefaults(
  defineProps<{
    propsList: FormItem[]
    propsValue: BaseObject
    labelWidth?: string
    elColSpan?: number
    showLable?: boolean
    rules?: FormRules
    btnPlacement?: string
  }>(),
  {
    propsList: () => [],
    propsValue: () => ({}),
    labelWidth: 'auto',
    elColSpan: 6,
    showLable: true,
    btnPlacement: 'left',
  },
)
// let formData = toRefs(props.propsValue) //defineProps声明的属性，不可修改，vue已设置为readonly，但是props.key.key可修改。propsValue是在父组件声明的reactive数据，传入子组件保持响应式
let formData = props.propsValue //formRef.value?.validate校验的值是原始reactive值，toRefs包括后无法校验

const emit = defineEmits(['cancel', 'confirm']) //emit 第一个参数被vue定义为defineEmits的联合类型

const formRef = ref<FormInstance>()

// 重置表单
const resetFields = () => {
  formRef.value?.resetFields()
}
// 清空输入校验
const clearValidate = () => {
  formRef.value?.clearValidate()
}
// 向父组件暴露当前住组件的方法
defineExpose({
  resetFields,
  clearValidate,
})

// 80 文件上传 为各个表单项组件设置ref
let refMap = reactive<BaseObject>({})
const setRef = (el, item) => {
  refMap[item.prop] = el
}

// 取消按钮
const handleCancel = () => {
  emit('cancel')
  clearValidate()
}

// 保存按钮
const handleSave = () => {
  formRef.value?.validate(valid => {
    if (valid) {
      nextTick(async () => {
        await refMap.file?.confirmUpload() //默认当前只注册了一个上传组件，且表单项prop值是file TODO
        emit('confirm', formData)
      })
    } else {
      // ElMessage.error('请检查输入')
    }
  })
}

// 上传组件80：文件上传成功回调
const uploadSuccessCB = (data: any) => {
  console.log('uploadSuccessCB')
  formData.file = data || {}
}

onBeforeMount(() => {
  // 数据字典：el-select 选项值集，默认数据结构[{name:'',value:''}]。后端暂无相应接口 TODO
  // props.propsList.map(item => {
  //   if (item.valueSetCode) {
  //     findValueBySetCode({ valueSetCode: item.valueSetCode })
  //       .then((response: any) => {
  //         if (response.statusCode == 200) {
  //           item.options = response.responseData
  //         }
  //       })
  //       .catch(error => {
  //         console.log('CommonForm-findValueBySetCode-error', error)
  //       })
  //   }
  // })
})
onMounted(() => {})
</script>

<style scoped lang="less">
@import '@/assets/css/searchAndTableBase.less';
.common-form-component {
  :deep .el-form-item {
    margin-bottom: 20px !important;
  }
  .btn-block {
    &.left {
      text-align: left;
    }
    &.right {
      text-align: right;
    }
  }
  .custom-label {
    display: inline-block;
    margin-bottom: 0 !important;
    .el-tooltip__trigger {
      vertical-align: middle;
      margin-left: 3px;
    }
  }
  :deep .el-upload-list {
    width: 200px;
  }
  :deep .el-input {
    width: 250px;
    height: 32px;
  }
  :deep .el-select {
    width: 250px;
    height: 32px;
  }
  :deep .el-autocomplete {
    width: 250px;
    height: 32px;
  }
  :deep .el-textarea {
    width: 400px;
  }
}
</style>
